import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ArrowIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 26.19 26.19" {...props}>
    <path d="M26.19.5v0a.41.41,0,0,0,0-.11.61.61,0,0,0-.07-.14s0,0-.05-.06L25.94.05h0l-.11,0L25.7,0h-.05l-.17,0L.29,9.93a.52.52,0,0,0-.29.46.51.51,0,0,0,.26.44L10,16.21l5.39,9.72a.52.52,0,0,0,.46.26h0a.48.48,0,0,0,.44-.29L26.14.72a.41.41,0,0,0,.05-.19ZM24.08,2.82,15.76,24.57,11,15.93Zm-.71-.71L10.26,15.22,1.62,10.43ZM10,16.15Z" />
  </SvgIcon>
));

export default React.memo(ArrowIcon);
